import { useContext } from "react"; 
import { AlertContext } from "../contexts/alert.context";

const useAlert = () => useContext(AlertContext);

export default useAlert;
